<template>
  <v-dialog v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-icon v-if="useSmallIcon" small v-on="on" @click="dialog = true">mdi-eye</v-icon>
      <v-btn v-if="!useSmallIcon" color="default" v-on="on" @click="dialog = true">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <PdfViewer :fileUrl="getFileUrl(documentId)" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.native="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ViewDoc',
  props: {
    documentId: {
      type: String,
      default: '',
    },
    useSmallIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters('documents', ['getDocument', 'getFileUrl']),
  },
};
</script>

<style lang="scss" scoped>

</style>
